import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {stores} from "../stores";
import {sysex} from "../utils/midi";
import {DUMP_PRESET_NN_RECALL, SYSEX_COMMANDS} from "../model/commands";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCaretLeft, faCaretRight, faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {UTILITIES_NAMES} from "../model/preset";
import "./SinglePreset.css";

export const SinglePreset = observer(() => {

    // const preset = stores.model.presets[stores.state.activePreset];

    const [n, setN] = useState(stores.state.activePreset.toString(10));
    // const [name, setName] = useState('');

    useEffect(() => {
        setN(stores.state.activePreset.toString(10));
    }, [stores.state.activePreset]);

    function readPreset() {
        stores.midi.send(sysex([...SYSEX_COMMANDS[DUMP_PRESET_NN_RECALL], stores.state.activePreset]));
    }

    function selectPreset(n: number) {
        // if (isNaN(n)) return;
        // console.log(n);
        stores.state.selectPreset(n);
        readPreset();
    }

    function savePreset() {
        stores.midi.save(stores.state.activePreset);
    }

    function isValidPresetNumber(s: string) {
        const n = parseInt(s, 10);
        return /^\d+$/.test(s) && !isNaN(n) && (n <= 105);
    }

    function onNChange(e: any) {
        setN(e.target.value);
        if (!isValidPresetNumber(e.target.value)) return;
        selectPreset(parseInt(e.target.value, 10));
    }

    function dec() {
        let m = parseInt(n);
        let p;
        p = isNaN(m) ? 0 : m - 1;
        if (p < 0) p = 105;
        setN(p.toString());
        selectPreset(p);
    }

    function inc() {
        let m = parseInt(n);
        let p;
        p = isNaN(m) ? 0 : (m + 1);
        if (p > 105) p = 0;
        setN(p.toString());
        selectPreset(p);
    }

    function setName(name: string) {
        stores.memory.setPresetName(name, stores.state.activePreset);
    }

    // const s = getPresetName(preset);
    // console.log(s, s.split(""))

    // const uname = UTILITIES_NAMES[]

    return (
        <div className="main-content p-20 flex">
            <div className="mt-20 grid-2cols">
                <div className="">
                    Preset&nbsp;number:
                </div>
                <div>
                    <div className="row">
                        <button onClick={dec} className="nav-button"><FontAwesomeIcon icon={faCaretLeft} /></button>
                        <input type="text" size={3} value={n} onChange={onNChange} className="number-input" tabIndex={1} />
                        <button onClick={inc} className="nav-button"><FontAwesomeIcon icon={faCaretRight} /></button>
                        {!isValidPresetNumber(n) && <span className="ml-10 red"><FontAwesomeIcon icon={faExclamationCircle} /></span>}
                        <div className="ml-10 bold">{UTILITIES_NAMES[stores.state.activePreset] ?? ''}</div>
                    </div>
                    <div className="help-text pt-5 ml-35">0..105</div>
                </div>
                <div className="">
                    Preset&nbsp;name:
                </div>
                <div>
                    <div className="row stretch">
                        <input type="text" value={stores.memory.getPresetName(stores.state.activePreset)}
                               onChange={e => setName(e.currentTarget.value)} tabIndex={2} className="name-input-big" />
                        <button className="save-button" onClick={savePreset} disabled={!stores.midi.deviceFound}>SAVE</button>
                    </div>
                    <div className="help-text pt-5">max 8 characters (ASCII)</div>
                </div>
                <div className="span-2cols mt-10">
                    Utils X &amp; Y names are preset index 100 to 105.
                </div>
            </div>
        </div>
    );

});
